import { render } from "./HiViewNoResult.vue?vue&type=template&id=615d9e9a"
import script from "./HiViewNoResult.vue?vue&type=script&lang=js"
export * from "./HiViewNoResult.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__